// extracted by mini-css-extract-plugin
module.exports = {"nounbrInfoHeader":"NounBRInfoCard_nounbrInfoHeader__2i9gL","nounbrInfoRow":"NounBRInfoCard_nounbrInfoRow__2XMbD","nounbrInfoRowText":"NounBRInfoCard_nounbrInfoRowText__2vMVp"};